import { useTranslation } from "react-i18next";
import Select from "react-select";
import { getCustomSelectStyles } from "../../../admin/shared";

interface Group {
  id: string;
  name: string;
  count: number;
}

interface SelectOption {
  value: string;
  label: string;
}

interface GroupFilterProps {
  selectedGroup: string;
  onGroupChange: (group: string) => void;
  groups: Group[];
  themeClasses: {
    text: string;
    inputBg: string;
    inputBorder: string;
  };
  isDarkMode?: boolean;
  isReseller?: boolean;
  selectedCompany?: string | null;
}

export default function GroupFilter({
  selectedGroup,
  onGroupChange,
  groups,
  isDarkMode = false,
  isReseller = false,
  selectedCompany,
}: GroupFilterProps) {
  const { t } = useTranslation("lite");

  // Opciones de grupos
  const groupOptions: SelectOption[] = groups.map((group) => ({
    value: group.id,
    label: `${group.name} (${group.count})`,
  }));

  const selectedGroupOption =
    groupOptions.find((opt) => opt.value === selectedGroup) || null;

  return (
    <div className="space-y-3">
      {/* Selector de Grupo (solo visible si no es reseller o si ya seleccionó una compañía) */}
      {(!isReseller || selectedCompany) && (
        <div>
          {/* Sin etiqueta "Filtrar por grupo": el propio control lo dice
              ("Selecciona un grupo"), y ese renglón es para el buscador. */}
          <Select
            aria-label={t("filters.filterByGroup")}
            value={selectedGroupOption}
            // En el menú, "Todos los grupos (31)"; ya elegido, "Selecciona un
            // grupo (todos)": invita a filtrar en vez de parecer un dato.
            formatOptionLabel={(opt: any, meta: any) =>
              meta.context === "value" && opt.value === "all"
                ? t("filters.selectGroupAll")
                : opt.label
            }
            onChange={(option: any) => onGroupChange(option?.value || "all")}
            options={groupOptions}
            placeholder={t("filters.selectGroup")}
            isSearchable
            isClearable={false}
            styles={getCustomSelectStyles(isDarkMode)}
            noOptionsMessage={() => t("filters.noGroups")}
          />
        </div>
      )}
    </div>
  );
}
